<template>
  <div class="footer">
    <div class="container">
      <div class="u-flex u-col-top u-row-between menu" style=" cursor: pointer;">
        <div class="menu-item">
          <div class="label">联系我们</div>
          <ul class="contact-us">
            <li>联系方式:{{ footer.contact_information }}</li>
            <li>商务邮箱:{{ footer.business_email }}</li>
            <li>客服 QQ:{{ footer.customer_service_qq }}</li>
            <li>联系地址:{{ footer.contact_address }}</li>
          </ul>
        </div>
        <div class="menu-item">
          <div class="label">快捷导航</div>
          <ul class="u-flex u-flex-wrap shortcut-nav" v-for="(item, index) in quick_navigation">
            <li @click="goTo(item.id)">{{ item.name }}</li>
          </ul>
        </div>
        <div class="menu-item">
          <div class="label">关注我们</div>
          <ul class="mt10">
            <li class="qrcode">
              <img :src="baseUrl + footer.contact_qr_code" alt="二维码">
            </li>
            <li class="scan">扫码添加好友</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="icp" style="font-size: 12px">
      <div style="margin-bottom: 10px">
        声明：卓泓HTTP仅提供代理IP服务；严禁用户使用卓泓HTTP从事任何违法犯罪行为，产生的相关责任用户自负，对此卓泓HTTP不承担任何法律责任
      </div>
      <div >
        {{ footer.record_number  || '版权归属 北京卓泓科技有限公司'}}
      </div>
    </div>
  </div>
</template>

<script>
import {baseUrl} from "@/utils/config";

export default {

  data() {
    return {
      baseUrl: baseUrl,
      footer: {
        contact_information: '',
        business_email: '',
        customer_service_qq: '',
        contact_address: '',
        contact_qr_code: '',
      },
      bottom_list: [],
      quick_navigation: [],
    }
  },
  created() {
    this.$api.home.index().then(res => {
      Object.assign(this.footer, res.data.footer)
      this.bottom_list = res.data.bottom_list
      this.quick_navigation = res.data.quick_navigation
    })

  },
  methods: {
    goTo(id) {

      // 跳转到FaqDetail页面并传递参数
      this.$router.push({
        path: '/faqDetail',
        query: {
          cid: id
        }
      })
    }
  },

}
</script>

<style scoped>
.footer {
  padding-top: 80px;
  font-size: 12px;
  background: #f3f6fb;
}

.menu {
  padding: 0 60px;
}

.menu-item {
  width: 33.3333%;
}

.menu-item:last-child {
  width: 160px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.label {
  padding-bottom: 16px;
  color: #000;
  font-size: 20px;
}

.menu-item:last-child .label {
  width: 160px;
  text-align: left;
}

.contact-us li {
  line-height: 48px;
  color: #666;
  font-size: 14px;
}

.shortcut-nav {
  width: 100%;
}

.shortcut-nav li {
  width: 33.3333%;
  line-height: 48px;
  color: #666;
  font-size: 14px;
}

.qrcode img {
  width: 160px;
  height: 160px;
  display: block;
}

.scan {
  margin-top: 4px;
  color: #666;
  text-align: center;
}

.icp {
  margin-top: 80px;
  width: 100%;
  //height: 80px;
  //line-height: 80px;
  color: #fff;
  padding: 20px 0px;
  font-size: 16px;
  text-align: center;
  background: #292e36;
}
</style>
